import { ImageWrapperFragmentFragment } from '@fm-nx/contentful-types';

/**
 * Transform Contentful SDK image wrapper format to GraphQL ImageWrapperFragmentFragment format
 */
export const transformImageWrapperToGraphQL = (image: any): ImageWrapperFragmentFragment | null => {
    if (!image || !image.fields) return null;

    return {
        __typename: 'ImageWrapper',
        cloudinaryMedia: image.fields.cloudinaryMedia ?? null,
        description: image.fields.description ?? null,
        title: image.fields.title ?? null,
        altText: image.fields.altText ?? null,
        sys: {
            __typename: 'Sys',
            id: image.sys.id,
        },
    };
};
